export const minRecurringTableColumnsWidth = {
  customerId: 150,
  recurringPeriod: 150,
  paymentCurrency: 77,
  mappingResultCode: 76,
};
